import { useRevealOnScroll } from "@/hooks/useReveal";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryMarquee from "./components/CategoryMarquee";
import SectionCurve from "./components/SectionCurve";
import BeforeAfter from "./components/BeforeAfter";
import PainSection from "./components/PainSection";
import DesireFlow from "./components/DesireFlow";
import Transformation from "./components/Transformation";
import PlayMenuIntro from "./components/PlayMenuIntro";
import Capabilities from "./components/Capabilities";
import ProductDemo from "./components/ProductDemo";
import Audience from "./components/Audience";
import SocialProof from "./components/SocialProof";
import Plans from "./components/Plans";
import FreeTrial from "./components/FreeTrial";
import Representatives from "./components/Representatives";
import InstagramSection from "./components/InstagramSection";
import Faq from "./components/Faq";
import LeadForm from "./components/LeadForm";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

export default function Home() {
  useRevealOnScroll();

  return (
    <main className="bg-background-50">
      <Navbar />
      <Hero />
      <SectionCurve from="foreground-950" to="background-50" />
      <BeforeAfter />
      <CategoryMarquee />
      <PainSection />
      <SectionCurve from="background-50" to="foreground-950" />
      <DesireFlow />
      <Transformation />
      <PlayMenuIntro />
      <SectionCurve from="foreground-950" to="background-50" />
      <Capabilities />
      <SectionCurve from="background-50" to="foreground-950" />
      <ProductDemo />
      <SectionCurve from="foreground-950" to="background-100" />
      <Audience />
      <SocialProof />
      <SectionCurve from="background-100" to="background-50" />
      <Plans />
      <SectionCurve from="background-50" to="background-100" />
      <FreeTrial />
      <SectionCurve from="background-100" to="background-50" />
      <Representatives />
      <InstagramSection />
      <Faq />
      <SectionCurve from="background-50" to="background-100" />
      <LeadForm />
      <SectionCurve from="background-100" to="foreground-950" />
      <FinalCTA />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}